import React from "react";
import styles from "./ZmianaHaslaOkno.module.css";

/**
 * [HASLA-LOKALNE, decyzja właściciela 2026-09-27] Konto NIELOKALNE (Office 365) na ekranie zmiany hasła (wejście adresem
 * /zmiana-hasla) — informacja zamiast formularza. „pozwalaj im na zmiane i dla admina ale tylko dla lokalsow”.
 *
 * [HASLA-O365, właściciel 2026-09-28] „resetowanie hasla przycisk ma miec tylko osoba, ktora jest nie office365” — BEZ żadnej
 * opcji hasła: zdjęty przycisk-łącze „Zmień hasło w Office 365”. Zostaje samo zdanie, że konto loguje się przez Office 365.
 */
const InformacjaHaslaO365 = () => (
    <div className={styles.informacjaO365} data-testid="haslo-o365">
        <strong>Twoje konto loguje się przez Office 365.</strong>
        {/* [HASLA-LOKALNE poprawka 2026-09-28, uwaga przeglądu] BYŁO: „aplikacja go nie przechowuje” — 3 konta O365 miały też
            hash hasła aplikacji, który otwierał logowanie. Od poprawki hasło aplikacji nie loguje konta Office 365. */}
        <p>
            Do aplikacji logujesz się przyciskiem Office 365 — hasło aplikacji nie otwiera konta Office 365. Hasło zmieniasz
            w Office 365 (poczta pracownicza) albo razem z hasłem do komputera służbowego; aplikacja go nie zmienia.
        </p>
    </div>
);

export default InformacjaHaslaO365;
